export const LIST_TYPE = 'onlineshoppinglist';
